import { CtaSectionContent, CtaSectionForm, CtaSectionWrapper } from "./style";
import EmailForm from "./EmailForm";

const CtaSectionAction = () => {
  const handleSubmit = () => {};
  return (
    <CtaSectionWrapper>
      <CtaSectionContent>
        <h2>
          <span>Stay in the loop</span> <br />
          Get the latest insights
        </h2>
      </CtaSectionContent>
      <CtaSectionForm>
        <EmailForm showIcon={false} onSubmit={handleSubmit} />
        <p>
          By clicking send you'll receive occasional emails from Vyga. You
          always have the choice to unsubscribe within every email you receive.
        </p>
      </CtaSectionForm>
    </CtaSectionWrapper>
  );
};

export default CtaSectionAction;
